import { Node } from '@antv/x6'
import classNames from "classnames"
import { SvgElem } from "@/components/SvgElem/SvgElem"
import { useCellStatusClassName } from '../plugins/UnitSimPlugin/CellsSimHooks'

export const LineJumpNode = ({node}: {node: Node}) => {
  const data = node.getData()
  const streamId = data.streamId;
  const statusClass = useCellStatusClassName(streamId)

  return <div className={classNames('fs-node', statusClass)}>
    <SvgElem className={classNames('fs-svg-node')} imageStr={data.image} />
  </div>
}

